import { Grid } from "@material-ui/core";
import React from "react";
import { WarningIcon } from "App/Assets";
import { MasterButton, Modal } from "App/Component/ui";
import { useState } from "react";

export default function ModalDeleteConfirm({
  setShowModalDeleteConfirm,
  confirmHandle,
  msg = "Anda yakin ingin menghapus record ini?",
  labelConfirm = "Hapus",
  title = "Hapus Record",
}) {
  const [disabled, setDisabled] = useState(false);
  return (
    <>
      <Modal
        backgroundTitle='red'
        title={title}
        width={"30%"}
        show={setShowModalDeleteConfirm}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "20px",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}>
          <WarningIcon width='150px' height='150px' />
          <p className='fs-12'>{msg}</p>
        </div>

        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            outline={true}
            className={"mr-1 mt-1"}
            type={"button"}
            color='secondary'
            name='Batal'
            onClick={() => setShowModalDeleteConfirm(false)}
            size='md'
          />
          <MasterButton
            disabled={disabled}
            className={"mt-1"}
            type={"button"}
            color={disabled ? "secondary" : "danger"}
            onClick={() => {
              confirmHandle();
              setDisabled(true);
            }}
            name={disabled ? "Loading..." : labelConfirm}
            size='md'
          />
        </Grid>
      </Modal>
    </>
  );
}
